import { useEffect, useState } from "react";
import {
  Box,
  ClickAwayListener,
  makeStyles,
  Typography,
  Link,
} from "@material-ui/core";
import { MoreHoriz } from "@material-ui/icons";
import { helpDropdownOptions } from "./ModalsData";
import { HelpDropdownType } from "./type";

const HelpDropdown = ({ borderRadius }: HelpDropdownType) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const [currentOption, setCurrentOption] = useState(0);

  const classes = useStyles({ showDropdown, borderRadius });

  useEffect(() => {
    setShowDropdown(false);
  }, [currentOption]);

  return (
    <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
      <Box className={classes.container}>
        <Box
          className={classes.itemShowContainer}
          onClick={() => setShowDropdown((val) => !val)}
        >
          <MoreHoriz className={classes.infoIcon} />
        </Box>

        {showDropdown && (
          <Box className={classes.itemsContainer}>
            {helpDropdownOptions.map((option, index) => (
              <Link className={classes.item} href={option.url} target="_blank">
                <Box display="flex" alignItems="center" marginBottom="5px">
                  <Box className={classes.iconContainer}>
                    <img src={option.icon} />
                  </Box>

                  <Typography className={classes.title}>
                    {option.title}
                  </Typography>
                </Box>
                <Typography className={classes.description}>
                  {option.description}
                </Typography>
              </Link>
            ))}
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default HelpDropdown;

const useStyles = makeStyles((theme) => ({
  container: {
    width: "50px",

    background: "#190E2B",

    border: "1px solid rgba(255, 255, 255, 0.58)",

    borderRadius: 10,
    cursor: "pointer",

    position: "relative",
  },

  currentItem: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontWeight: 400,
    color: "#fff",
  },

  item: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontWeight: 400,
    color: "#fff",
    padding: "1rem",

    "&:hover": {
      textDecoration: "none",
    },
  },

  itemsContainer: {
    position: "absolute",
    top: 60,
    width: "250px",
    right: 0,

    background: "linear-gradient(139.63deg, #605384 -23.88%, #0F0824 100%)",

    border: "1px solid rgba(255, 255, 255, 0.28)",

    zIndex: 10000,

    borderRadius: "25px",

    boxShadow:
      "inset 0px 2.36078px 10.6235px rgba(8, 5, 18, 0.2), inset 0px 0.590196px 23.6078px rgba(8, 5, 18, 0.2)",
    backdropFilter: "blur(40px)",

    padding: "0 20px",
  },

  itemShowContainer: {
    // padding: "0 2rem",

    height: "100%",
    width: "100%",
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
  },
  infoIcon: {
    color: "#fff",
  },

  iconContainer: {
    height: 30,
    width: 30,
    backgroundColor: "#797290",
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    borderRadius: 10,
  },

  title: {
    fontSize: "18px",
    lineHeight: "27px",
    fontWeight: 500,
    color: "#fff",
  },

  description: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#fff",
  },
}));
